import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAuthToken } from "jwt-storage-lib";
import { buildUrlQuery } from "@builder/utils/buildUrlQuery";
import { Order } from "@builder/types/Order.type";

export const ordersApi = createApi({
    reducerPath: "ordersApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${import.meta.env.VITE_URL_HUB_API}order`,
        prepareHeaders: async headers => {
            const token = await getAuthToken();

            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }

            return headers;
        }
    }),
    tagTypes: ["orders"],
    endpoints: builder => ({
        getOrders: builder.query<
            Order[],
            {
                companyId: string;
                search?: string;
                offset?: number;
                limit?: number;
                includeCustomer?: boolean;
                includeEmployee?: boolean;
                organizationId?: string;
            }
        >({
            query: ({ companyId, ...query }) => `/builder/query/${companyId}?${buildUrlQuery(query)}`,
            providesTags: ["orders"]
        }),
        getOrdersByIds: builder.query<Order[], { companyId: string; ids: string[]; organizationId?: string }>({
            query: ({ companyId, ids, organizationId }) => {
                const params = new URLSearchParams({ ids: ids.join(",") });
                if (organizationId) {
                    params.append("organizationId", organizationId);
                }
                return `/builder/by-ids/${companyId}?${params.toString()}`;
            },
            providesTags: ["orders"]
        })
    })
});

export const { useGetOrdersQuery, useGetOrdersByIdsQuery } = ordersApi;
